import { ViewModel,View } from "binder"
import { IDefaultValueManipulator } from "../defaultValueManipulator";
import  { NullView } from "./null-view"
import { IMemberContainer } from "../../../dataModelBuilder-viewModel";

export class NullViewModel extends ViewModel implements IDefaultValueManipulator{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }

    GetDefaultView(): View <ViewModel> {
        return new NullView();
    }
    public getTypeId(): string {
        return "VM-7028132F-FCA0-45B7-9B8C-F31EDFFCB3AF"
    }

    
    setDefaultValue(defaultValue: any): void {
    }
    getDefaultValue():any {
        return null;
    }

    verify(owningClass : IMemberContainer): string[] {
        return []
    }
}
